<template>
  <div class="rounded-lg border-l-4 p-5 mb-6 bg-white shadow-xs" :class="borderClass">
    <div class="flex items-start gap-4">
      <span class="text-3xl shrink-0">{{ icon }}</span>
      <div class="flex-1">
        <h3 class="text-lg font-bold text-gray-900">{{ title }}</h3>
        <p v-if="subtitle" class="text-sm text-gray-600 mt-0.5">{{ subtitle }}</p>
        <div v-if="highlights.length" class="flex flex-wrap gap-2 mt-3">
          <span
            v-for="(highlight, index) in highlights"
            :key="index"
            class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium"
            :class="chipClasses"
          >
            {{ highlight }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const COLOR_MAP = {
  green: {
    border: "border-green-500",
    chip: "bg-green-100 text-green-800",
  },
  purple: {
    border: "border-purple-500",
    chip: "bg-purple-100 text-purple-800",
  },
  blue: {
    border: "border-blue-500",
    chip: "bg-blue-100 text-blue-800",
  },
  orange: {
    border: "border-orange-500",
    chip: "bg-orange-100 text-orange-800",
  },
};

export default {
  name: "OfferHighlight",
  props: {
    icon: { type: String, default: "" },
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    highlights: { type: Array, default: () => [] },
    color: { type: String, default: "green" },
  },
  computed: {
    borderClass() {
      return (COLOR_MAP[this.color] || COLOR_MAP.green).border;
    },
    chipClasses() {
      return (COLOR_MAP[this.color] || COLOR_MAP.green).chip;
    },
  },
};
</script>
